import { render } from "./FavoriteLink01.vue?vue&type=template&id=55db36e8&scoped=true"
import script from "./FavoriteLink01.vue?vue&type=script&lang=js"
export * from "./FavoriteLink01.vue?vue&type=script&lang=js"

import "../assets/irentcar/css/bundle.min.css?vue&type=style&index=0&id=55db36e8&lang=css&scoped=true"

import exportComponent from "D:\\WorkSites\\Ticket Marketplace\\irent-ticket-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55db36e8"]])

export default __exports__